// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const LegendActionsRoot = styled.div`
  flex: 0 0 auto;
  position: relative;
  align-items: center;
  margin-left: auto;
`;
